/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_IntroInputs */

const en_guide_json_syntax_errors_intro = /** @type {(inputs: Guide_Json_Syntax_Errors_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON's strict syntax rules mean that even a small mistake will cause a parsing error. Unlike JavaScript, JSON has no tolerance for trailing commas, single quotes, or unquoted keys. This guide covers the most frequent errors developers encounter and how to fix each one.`)
};

const ko_guide_json_syntax_errors_intro = /** @type {(inputs: Guide_Json_Syntax_Errors_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON의 엄격한 구문 규칙은 작은 실수 하나로도 파싱 오류를 일으킵니다. JavaScript와 달리 JSON은 후행 쉼표, 작은따옴표, 따옴표 없는 키를 허용하지 않습니다. 이 가이드는 개발자들이 가장 자주 겪는 오류와 각각의 해결 방법을 다룹니다.`)
};

const ja_guide_json_syntax_errors_intro = /** @type {(inputs: Guide_Json_Syntax_Errors_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONの厳密な構文ルールにより、小さなミスでもパースエラーが発生します。JavaScriptとは異なり、JSONでは末尾のカンマ、シングルクォート、クォートなしのキーは許容されません。このガイドでは、開発者が最もよく遭遇するエラーとその修正方法を解説します。`)
};

/**
* | output |
* | --- |
* | "JSON's strict syntax rules mean that even a small mistake will cause a parsing error. Unlike JavaScript, JSON has no tolerance for trailing commas, single qu..." |
*
* @param {Guide_Json_Syntax_Errors_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_intro = /** @type {((inputs?: Guide_Json_Syntax_Errors_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_intro(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_intro(inputs)
	return ja_guide_json_syntax_errors_intro(inputs)
});